import React from "react";
import {DropDownList} from "@progress/kendo-react-dropdowns";

const OwnerDropDown = (props) => {
  const handleChange = (e) => {
    if (props.onChange) {
      props.onChange({
        dataIndex: 0,
        dataItem: props.dataItem,
        field: props.field,
        syntheticEvent: e.syntheticEvent,
        value: e.target.value.value,
      });
    }
  };

  const generateOptions = () => {
    let options = [{
      value: "CLIENT",
      text: "Client",
    }];


    if (OwnerDropDown.hasSpouse) {
      options.push(
          {
            value: "CO_CLIENT",
            text: "Spouse",
          }
      );
    }

    return options;
  }

  const options = generateOptions();

  const { dataItem } = props;
  const field = props.field || "";
  const dataValue = dataItem[field] === null ? "" : dataItem[field];

  if (!dataItem.inEdit) {
    const selectedOption = options.find((c) => c.value === dataValue);
    return <td>
      {selectedOption.text}
    </td>
  }

  const getValidationOwner = () => {
    const isOwnerValid = options.find(e => e.value === props.dataItem.owner) !== undefined;
    return isOwnerValid;
  }

  return (
      <td>
        <DropDownList
            style={{
              width: "100px",
            }}
            onChange={handleChange}
            value={options.find((c) => c.value === dataValue)}
            data={options}
            textField="text"
            valid={getValidationOwner()}
        />
      </td>
  );
};

export default OwnerDropDown;
